<template lang="pug">
  .quotation-inline#quotation-inline(:class="{ 'quotation-inline--openBoxPassengers': passengersVisible }")
    .quotation-inline__collapse
      span.quotation-inline__collapse-text Sua cotação
    button.quotation-inline__arrow(@click="showFilter = !showFilter" :class="{ 'quotation-inline__arrow--open' : showFilter }" :disabled="disabledBtn")
    .quotations__container-overflow(v-if="appearWarning")
      .quotations__container--warning
        svg(name="icon-error" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M21.5 11C21.5 5.20101 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5C16.799 21.5 21.5 16.799 21.5 11ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 5.83333C11.3846 5.83333 11.7016 6.12286 11.745 6.49587L11.75 6.58333V13.3333C11.75 13.7475 11.4142 14.0833 11 14.0833C10.6154 14.0833 10.2984 13.7938 10.255 13.4208L10.25 13.3333V6.58333C10.25 6.16912 10.5858 5.83333 11 5.83333ZM11 17.0833C11.4142 17.0833 11.75 16.7475 11.75 16.3333C11.75 15.9191 11.4142 15.5833 11 15.5833C10.5858 15.5833 10.25 15.9191 10.25 16.3333C10.25 16.7475 10.5858 17.0833 11 17.0833Z" fill="#DF2E24")
        span(v-if="hasIdOld") Atenção! O seguro viagem foi atualizado e por isso o destino precisa ser escolhido novamente.
        span(v-else) O período escolhido anteriormente já expirou, por favor selecione uma nova data.
    .quotation-inline__resume(v-if="!showFilter")
      ul.quotation-inline__resume__list
        li.quotation-inline__resume__list__item.quotation-inline__resume__list__item--destiny(v-if="countriesSelected.length > 0 || travels === 'trip'")
          span.quotation-inline__resume__list__item__label {{ formatCountriesLabel }}
        li.quotation-inline__resume__list__item.quotation-inline__resume__list__item--passengers
          span.quotation-inline__resume__list__item__label {{ totalPassengersCounter }} {{ totalPassengersCounter == 1 ? 'passageiro' : 'passageiros' }}
        li.quotation-inline__resume__list__item.quotation-inline__resume__list__item--travelsDate
          span.quotation-inline__resume__list__item__label {{ input.initialDate | date }} - {{ travels === 'multitrip' ? annualPlanValid : input.endDate | date }}
        li.quotation-inline__resume__list__item
          button.quotation-inline__resume__list__item__button(@click="showFilter = !showFilter") Alterar cotação
    .quotation-inline__container(v-else)
      //- .quotation__travelsType
      //-   .quotation__travelsType__options(@click="chooseTravelsType('trip')")
      //-     input.quotation__travelsType__options__inputRadio(type="radio" id="travelsTypeTrip" name="travelsTypeTrip" :checked="travels === 'trip'")
      //-     i.quotation__travelsType__options__icon
      //-     label.quotation__travelsType__options__label(for="trip") Uma Viagem
      //-   .quotation__travelsType__options(@click="chooseTravelsType('multitrip')")
      //-     input.quotation__travelsType__options__inputRadio(type="radio" id="TravelsTypeMultitrip" name="TravelsTypeMultitrip" :checked="travels === 'multitrip'")
      //-     i.quotation__travelsType__options__icon.quotation__travelsType__options__icon--multitrip
      //-     label.quotation__travelsType__options__label(for="multitrip") Anual Multi Trip

      .quotation__travelsDuration(v-if="travels === 'multitrip'")
        label.quotation__label Duração por viagem
        .quotation__travelsDuration__content
          .quotation__travelsDuration__options(@click="chooseTravelsDuration('Y15')")
            input.quotation__travelsDuration__options__inputRadio(type="radio" id="travelsDurationY15" name="travelsDurationY15" :checked="travelsDuration === 'Y15'")
            i.quotation__travelsDuration__options__icon
            label.quotation__travelsDuration__options__label(for="Y15") 15 Dias
          .quotation__travelsDuration__options(@click="chooseTravelsDuration('Y30')")
            input.quotation__travelsDuration__options__inputRadio(type="radio" id="travelsDurationY30" name="travelsDurationY30" :checked="travelsDuration === 'Y30'")
            i.quotation__travelsDuration__options__icon
            label.quotation__travelsDuration__options__label(for="Y30") 30 Dias

      form.quotation-inline__form(@submit.prevent="apply" :class="travels === 'multitrip' ? 'quotation-inline__formMultitrip' : ''")

        .quotation-inline__fieldset.quotation-inline__fieldset--type(v-if="travels === 'trip'")
          b.quotation-inline__label Tipo de Viagem
          Toggle(:options="['Internacional', 'Nacional']" :selected="selectedType" @toggle="toggleNational")
        .quotation-inline__fieldset.quotation-inline__fieldset--destiny(v-if="travels === 'trip'")
          b.quotation-inline__label Para onde você vai?
          vSelect#destination-id.select__country(
            v-if="!isNational"
            multiple
            placeholder="Escolha seu país"
            v-model="inputCountry"
            :options="internationalDestinations"
            :components="{ Deselect }"
            :filterBy="filterCountries"
            @input="(newValue) => setCountries(newValue)"
            @search="(newValue) => inputCountrySearched = newValue"
          )
          .quotation-inline__input(v-else)
            span.quotation-inline__input__brasil Brasil
        .quotation-inline__fieldset.quotation-inline__fieldset--travelsDate(:style="[travels === 'multitrip' ? { marginLeft: 0 } : '']")
          .quotation-inline__fieldset--travelsDate__initialDate
            b.quotation-inline__label {{ travels === 'multitrip' ? 'Início do plano' : 'Ida' }}
            #step__datepicker-group--start(@click="openStartDatepicker")
              .quotation-inline__input(
                v-if="input.initialDate"
                :class="[{ 'quotation-inline__inputMultitrip': travels === 'multitrip' }, { 'quotation-inline__inputInvalid': isExpiredDate }]"
              ) {{ input.initialDate | date }}
              .quotation-inline__input(v-else) dd/mm/aaaa
              Datepicker(
                target="#step__datepicker-group--start"
                :label="labelDatepickerStart"
                :min="initialMinDate"
                :max="initialMaxDate"
                :visible="datepickerStartVisible"
                :close-event="closeStartDatepicker"
                v-model="input.initialDate"
                @change="syncDate"
              )
          .quotation-inline__fieldset--travelsDate__endDate(v-if="travels === 'trip'")
            b.quotation-inline__label Volta
            #step__datepicker-group--end(@click="openEndDatepicker")
              .quotation-inline__input(v-if="input.endDate") {{ input.endDate | date }}
              .quotation-inline__input(v-else) dd/mm/aaaa
              Datepicker(
                  target="#step__datepicker-group--end"
                  :label="labelDatepickerEnd"
                  :min="endMinMaxDate"
                  :max="endMaxDate"
                  :visible="datepickerEndVisible"
                  :close-event="closeEndDatepicker"
                  v-model="input.endDate"
                )

        .quotation-inline__fieldset.quotation-inline__fieldset--passengers(:class="{'quotation-inline__fieldset--open': passengersVisible}")
          b.quotation-inline__label Passageiros
          .quotation-inline__input(@click="passengersVisible = !passengersVisible") {{ ('0' + totalPassengersCounter).substr(-2) }} {{ totalPassengersCounter == 1 ? 'passageiro' : 'passageiros'}}
          .quotation-inline__passengers(v-if="passengersVisible" :class="travels === 'multitrip' ? 'passengersMultitrip' : ''")
            #passengersFortyYears.quotation-inline__passengers__group
              span.quotation-inline__passengers__group__label de 0 a 40 #[span anos de idade]
              .quotation-inline__passengers__group__numberPassengers
                button(
                  id="btnPassengersFortyYear--more"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="input.numberOfPassengersFourtyYears === 0"
                  @click.prevent="input.numberOfPassengersFourtyYears--"
                ) -
                .quotation-inline__passengers__group__numberPassengers__label {{ input.numberOfPassengersFourtyYears || '0+' }}
                button(
                  id="btnPassengersFortyYear--less"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="maxPassengers"
                  @click.prevent="input.numberOfPassengersFourtyYears++"
                ) +
            #passengersSixtyFourYears.quotation-inline__passengers__group
              span.quotation-inline__passengers__group__label de 41 a 64 #[span anos de idade]
              .quotation-inline__passengers__group__numberPassengers
                button(
                  id="btnPassengersSixtyFourYear--more"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="input.numberOfPassengersSixtyFourYears === 0"
                  @click.prevent="input.numberOfPassengersSixtyFourYears--"
                ) -
                .quotation-inline__passengers__group__numberPassengers__label {{ input.numberOfPassengersSixtyFourYears || '0+' }}
                button(
                  id="btnPassengersSixtyFourYear--less"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="maxPassengers"
                  @click.prevent="input.numberOfPassengersSixtyFourYears++"
                ) +
            #passengersSeventyFiveYears.quotation-inline__passengers__group
              span.quotation-inline__passengers__group__label de 65 a 75 #[span anos de idade]
              .quotation-inline__passengers__group__numberPassengers
                button(
                  id="btnPassengersSeventyFiveYear--more"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="input.numberOfPassengersSeventyFiveYears === 0"
                  @click.prevent="input.numberOfPassengersSeventyFiveYears--"
                ) -
                .quotation-inline__passengers__group__numberPassengers__label {{ input.numberOfPassengersSeventyFiveYears || '0+' }}
                button(
                  id="btnPassengersSeventyFiveYear--less"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="maxPassengers"
                  @click.prevent="input.numberOfPassengersSeventyFiveYears++"
                ) +
            #passengersEightyFiveYears.quotation-inline__passengers__group(v-if="travels !== 'multitrip'")
              span.quotation-inline__passengers__group__label de 76 a 85 #[span anos de idade]
              .quotation-inline__passengers__group__numberPassengers
                button(
                  id="btnPassengersEightyFiveYear--more"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="input.numberOfPassengersEightyFiveYears === 0"
                  @click.prevent="input.numberOfPassengersEightyFiveYears--"
                ) -
                .quotation-inline__passengers__group__numberPassengers__label {{ input.numberOfPassengersEightyFiveYears || '0+' }}
                button(
                  id="btnPassengersEightyFiveYear--less"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="maxPassengers"
                  @click.prevent="input.numberOfPassengersEightyFiveYears++"
                ) +
            //- #passengersNinetyNineYears.quotation-inline__passengers__group(v-if="travels !== 'multitrip'")
              span.quotation-inline__passengers__group__label de 86 a 99 #[span anos de idade]
              .quotation-inline__passengers__group__numberPassengers
                button(
                  id="btnPassengersNinetyNine--more"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="input.numberOfPassengersNinetyNineYears === 0"
                  @click.prevent="input.numberOfPassengersNinetyNineYears--"
                ) -
                .quotation-inline__passengers__group__numberPassengers__label {{ input.numberOfPassengersNinetyNineYears || '0+' }}
                button(
                  id="btnPassengersNinetyNineYear--less"
                  class="quotation-inline__passengers__group__numberPassengers__btn"
                  type="button"
                  :disabled="maxPassengers"
                  @click.prevent="input.numberOfPassengersNinetyNineYears++"
                ) +
            //

            div.quotation-inline__passengers__disclaimer
              img.quotation-inline__passengers__disclaimer__icon(src="~@/assets/icons/icon-warning.svg" alt="")
              span.quotation-inline__passengers__disclaimer__text Considere a idade na data de início da viagem

            button.quotation-inline__passengers__btnApply(type="button" @click.prevent="passengersVisible = false") Aplicar

        button.quotation-inline__button(:disabled="disabledBtn" :class="{ 'quotation-inline__button--partnerBB': $partnerBB }") Atualizar
</template>

<script>
import moment from 'moment'
import 'moment/locale/pt-br'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { queryString, removeAccent } from '@/helpers'
import Datepicker from '@/components/ui/CbDatepicker.vue'
import Toggle from '@/components/ui/Toogle.vue'
import vSelect from 'vue-select'

const MIN_DAYS = 1
const MAX_DAYS = 179
const INITIAL_MAX_DAYS = 365
const MAX_PASSENGERS = 10
const FORMAT_DATE = 'YYYY-MM-DD'

export default {
  components: {
    vSelect,
    Datepicker,
    Toggle
  },
  props: {
    isCampaign: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    passengersVisible () {
      if (this.passengersVisible && window.innerWidth <= 767) {
        document.getElementById('quotation-inline').style = 'position: initial;'
        document.querySelector('body').style = 'overflow: hidden;'
      } else {
        document.getElementById('quotation-inline').removeAttribute('style')
        document.querySelector('body').removeAttribute('style')
      }
    },
    initialDate () {
      this.input.initialDate = this.initialDate ? moment(this.initialDate).toDate() : null
      this.expiredDateCheck()
    }
  },
  data () {
    return {
      input: {
        countriesSelected: this.$store.state.quotation.countriesSelected,
        destinationId: this.$store.state.quotation.destinationId || this.$store.state.quotation.codDestination,
        initialDate: this.$store.state.quotation.initialDate ? moment(this.$store.state.quotation.initialDate).toDate() : null,
        endDate: this.$store.state.quotation.endDate ? moment(this.$store.state.quotation.endDate).toDate() : null,
        numberOfPassengersFourtyYears: this.$store.state.quotation.numberOfPassengersFourtyYears,
        numberOfPassengersSixtyFourYears: this.$store.state.quotation.numberOfPassengersSixtyFourYears,
        numberOfPassengersSeventyFiveYears: this.$store.state.quotation.numberOfPassengersSeventyFiveYears,
        numberOfPassengersEightyFiveYears: this.$store.state.quotation.numberOfPassengersEightyFiveYears,
        numberOfPassengersNinetyNineYears: this.$store.state.quotation.numberOfPassengersNinetyNineYears
      },
      Deselect: {
        render: createElement => createElement('span', 'x')
      },
      inputCountry: [],
      inputCountrySearched: [],
      labelDatepickerStart: 'Embarque no Brasil',
      labelDatepickerEnd: 'Desembarque no Brasil',
      datepickerStartVisible: false,
      datepickerEndVisible: false,
      passengersVisible: false,
      appearWarning: false,
      showFilter: false,
      travels: '',
      annualPlanValid: '',
      openDescriptionAnnualPlan: false,
      travelsDuration: this.$store.state.quotation.destinationId,
      isExpiredDate: false,
      internationalTrips: []
    }
  },
  created () {
    if (this.hasIdOld) {
      this.appearWarning = true
      this.showFilter = true

      this.$emit('appearQuotation', !this.appearWarning)
    } else {
      this.expiredDateCheck()
    }

    if (this.listDestinations.length === 0) this.getListDestinations()

    this.input.initialDate = this.initialDate ? moment(this.initialDate).toDate() : null
    this.inputCountry = this.countriesSelected
    this.travels = this.$store.state.quotation.destinationId === 'Y30' || this.$store.state.quotation.destinationId === 'Y15' ? 'multitrip' : 'trip'
    this.annualPlanValid = this.travels === 'multitrip' ? moment(this.$store.state.quotation.endDate).toDate() : null
  },
  computed: {
    ...mapState('travelSetup', ['listDestinations']),
    ...mapState('quotation', [
      'destinationId',
      'initialDate',
      'endDate',
      'countries',
      'countriesSelected',
      'numberOfPassengersFourtyYears',
      'numberOfPassengersSixtyFourYears',
      'numberOfPassengersSeventyFiveYears',
      'numberOfPassengersEightyFiveYears',
      'numberOfPassengersNinetyNineYears',
      'promoCode',
      'hasIdOld',
      'isNational'
    ]),
    ...mapGetters('quotation', ['destination']),
    ...mapGetters('travelSetup', ['internationalDestinations', 'brasilTrip']),
    lblDestination () {
      return (this.destination && this.destination.destination) || ''
    },
    selectedType () {
      return this.isNational ? 1 : 0
    },
    formatCountriesLabel () {
      if (!this.countriesSelected || !this.countriesSelected.length) return false
      if (this.countriesSelected.length === 1) return this.countriesSelected[0].label
      if (this.countriesSelected.length === 2) return `${this.countriesSelected[0].label} e ${this.countriesSelected[1].label}`
      if (this.countriesSelected.length === 3) return `${this.countriesSelected[0].label}, ${this.countriesSelected[1].label} e ${this.countriesSelected[2].label}`
      return `${this.countriesSelected[0].label}, ${this.countriesSelected[1].label}, ${this.countriesSelected[2].label} e mais ${this.countriesSelected.length - 3} ${this.countriesSelected.length === 4 ? 'país' : 'países'}`
    },
    disabledBtn () {
      const { initialDate, endDate } = this.input
      const validationNumberOfPassengers = this.totalPassengersCounter > 0
      // True quando todos os campos não estiver preenchido
      // False apenas quando todos os campos estiver preenchido
      return !((this.inputCountry.length > 0 || !!this.travelsDuration) && initialDate && endDate && validationNumberOfPassengers)
    },
    validationDestination () {
      return this.listDestinations.length > 0 && this.inputCountrySearched.length > 0
        ? !(this.listDestinations
          .map(({ label }) => removeAccent(label))
          .filter((name) => name.includes(removeAccent(this.inputCountrySearched))).length > 0)
        : false
    },
    validationInputCountry () {
      return this.$v.inputCountry.$invalid && this.$v.inputCountry.$dirty
    },
    totalPassengersCounter () {
      return this.input.numberOfPassengersFourtyYears + this.input.numberOfPassengersSixtyFourYears + this.input.numberOfPassengersSeventyFiveYears + this.input.numberOfPassengersEightyFiveYears + this.input.numberOfPassengersNinetyNineYears
    },
    maxPassengers () {
      return this.totalPassengersCounter === MAX_PASSENGERS
    },
    initialMinDate () {
      return moment().subtract(1, 'days').toDate()
    },
    initialMaxDate () {
      return moment(this.initialMinDate)
        .add(INITIAL_MAX_DAYS, 'days')
        .toDate()
    },
    endMinMaxDate () {
      return moment(this.input.initialDate, FORMAT_DATE)
        .add(MIN_DAYS, 'days')
        .toDate()
    },
    endMaxDate () {
      return moment(this.input.initialDate, FORMAT_DATE)
        .add(MAX_DAYS, 'days')
        .toDate()
    }
  },
  methods: {
    ...mapMutations('quotation', [
      'resetQuotation',
      'setNumberOfPassengersFourtyYears',
      'setNumberOfPassengersSixtyFourYears',
      'setNumberOfPassengersSeventyFiveYears',
      'setNumberOfPassengersEightyFiveYears',
      'setNumberOfPassengersNinetyNineYears',
      'setIsNational'
    ]),
    ...mapMutations('travelSetup', [
      'changeDestination',
      'changeCountries',
      'changeLeadName',
      'changeLeadEmail',
      'changeLeadPhone',
      'changeLink',
      'changeUrl',
      'changeInitialDate',
      'changeEndDate',
      'changeTravelType'
    ]),
    ...mapActions('travelSetup', [
      'getListDestinations',
      'patchLeadAction',
      'postLeadAction'
    ]),
    ...mapActions('quotation', ['create']),
    apply () {
      this.setNumberOfPassengersFourtyYears(this.input.numberOfPassengersFourtyYears)
      this.setNumberOfPassengersSixtyFourYears(this.input.numberOfPassengersSixtyFourYears)
      this.setNumberOfPassengersSeventyFiveYears(this.input.numberOfPassengersSeventyFiveYears)
      this.setNumberOfPassengersEightyFiveYears(this.input.numberOfPassengersEightyFiveYears)
      this.setNumberOfPassengersNinetyNineYears(this.input.numberOfPassengersNinetyNineYears)
      this.showFilter = false
      this.passengersVisible = false

      let query = {
        ...this.travels === 'trip'
          ? { countries: this.inputCountry.map(({ id }) => id) }
          : { cod_destination: this.input.destinationId || this.travelsDuration },
        initial_date: this.input.initialDate.toISOString().substr(0, 10),
        end_date: this.travels === 'multitrip' ? this.annualPlanValid.toISOString().substr(0, 10) : this.input.endDate.toISOString().substr(0, 10),
        fourty_years: this.input.numberOfPassengersFourtyYears,
        sixty_four_years: this.input.numberOfPassengersSixtyFourYears,
        seventy_five_years: this.input.numberOfPassengersSeventyFiveYears,
        eighty_five_years: this.input.numberOfPassengersEightyFiveYears,
        ninety_nine_years: this.input.numberOfPassengersNinetyNineYears
      }
      this.changeDestination(query.cod_destination)

      if (this.promoCode.value) query.promo_code = this.promoCode.value
      else delete query.promo_code

      if (!this.disabledBtn) {
        let conatParams = queryString(query)
        let leadURL = `${window.location.href.replace(/(.*)(#\/cotacoes\/.*?)(.*)/, '$1$2?')}${conatParams}`
        if (window.location.hash) leadURL = `${window.location.origin}${window.location.pathname}#/cotacoes/?${conatParams}`

        this.changeUrl(leadURL)
        // allowTermsUse is always true in the QuotationInline page, because the confimation was done in the prev page
        this.postLeadAction({ allowTermsUse: true })
        this.$router.push(`/cotacoes/?${conatParams}`)
      } else {
        window.dataLayer.push({
          'event': 'ciclic.event:travel/QuotationError'
        })
      }

      this.changeLink(window.location.href)
    },
    toggleNational (index) {
      this.setIsNational(index === 1)

      if (this.isNational) {
        this.internationalTrips = this.inputCountry.filter(country => country.id !== this.brasilTrip.id)

        this.setCountries([this.brasilTrip])
      } else {
        this.setCountries(this.internationalTrips)
      }
    },
    expiredDateCheck () {
      // checks if the applied date comes before the current date
      this.appearWarning = moment(this.initialDate).isBefore(moment().format('YYYY-MM-DD'))

      if (this.appearWarning) {
        this.isExpiredDate = true
        this.showFilter = true
      }

      this.$emit('appearQuotation', !this.appearWarning)
    },
    openStartDatepicker () {
      this.passengersVisible = false
      this.datepickerStartVisible = true
      this.datepickerEndVisible = false
    },
    openEndDatepicker () {
      this.passengersVisible = false
      this.datepickerStartVisible = false
      this.datepickerEndVisible = true
    },
    closeStartDatepicker () {
      this.passengersVisible = false
      this.datepickerEndVisible = false
      this.datepickerStartVisible = false
      this.changeInitialDate(moment(this.input.initialDate).format(FORMAT_DATE))
    },
    closeEndDatepicker () {
      this.passengersVisible = false
      this.datepickerEndVisible = false
      this.datepickerStartVisible = false
      this.changeEndDate(moment(this.input.endDate).format(FORMAT_DATE))
    },
    syncDate () {
      const totalDaysOfYear = 364
      let start = this.input.initialDate
      let endTargetDate = moment(start)
        .add(MIN_DAYS, 'days')
        .toDate()
      let end = this.input.endDate

      if (this.travels === 'multitrip') {
        this.annualPlanValid = moment(start).add(totalDaysOfYear, 'days').toDate()
        this.input.endDate = this.annualPlanValid
        this.changeEndDate(moment(this.annualPlanValid).format(FORMAT_DATE))
        this.openDescriptionAnnualPlan = true
      }

      if (start > end || endTargetDate > end) {
        setTimeout(() => { this.openEndDatepicker() }, 1)
        return (this.input.endDate = moment(start)
          .add(MIN_DAYS, 'days')
          .toDate())
      }
    },
    chooseTravelsDuration (duration) {
      this.travelsDuration = duration
      this.input.destinationId = this.travelsDuration

      this.changeDestination(this.destinationId)
    },
    chooseTravelsType (option) {
      const equalsOptions = option === this.travels
      this.travels = option
      const travelType = this.travels === 'multitrip' ? 'MULTI_TRIP' : 'SINGLE_TRIP'
      this.changeTravelType(travelType)

      if (option === 'trip') this.chooseTravelsDuration(false)
      if (!equalsOptions) {
        this.input = {
          destinationId: '',
          initialDate: null,
          endDate: null,
          numberOfPassengersFourtyYears: 0,
          numberOfPassengersSixtyFourYears: 0,
          numberOfPassengersSeventyFiveYears: 0,
          numberOfPassengersEightyFiveYears: 0,
          numberOfPassengersNinetyNineYears: 0
        }
      }
    },
    setCountries (payload) {
      this.inputCountry = payload
      this.changeCountries(payload)
    },
    filterCountries (option, label, search) {
      return (removeAccent(label) || '').indexOf(removeAccent(search)) > -1
    }
  },
  filters: {
    date (value, format = 'L') {
      return moment(value).format(format)
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";
.quotation {
  &__label {
    display: block;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 2px;
    width: 100%;
  }

  &__travelsType {
    display: flex;
    margin-bottom: 24px;
    margin-top: 40px;

    @media only screen and (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }

    &__options {
      align-items: center;
      cursor: pointer;
      display: flex;
      position: relative;

      @media only screen and (max-width: 455px) {
        padding: 0;
      }

      &:first-child {

        @media only screen and (max-width: 767px) {
          margin-bottom: 14px;
        }
      }

      &__inputRadio {
        position: absolute;
        left: -9999px;
      }

      input[type=radio]:checked ~ &__bg {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }

      &__icon {
        width: 202px;
        height: 40px;
        border: 1px solid #bdc2c6;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        position: relative;

        @media screen and (max-width: 767px) {
          border-radius: 8px;
        }

        &--multitrip {
          @media screen and (min-width: 768px) {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }

        input[type=radio]:checked ~ & {
          border-color: $color-purple-heart;
          background-color: $color-purple-heart;

          .themeBB & {
            border-color: #0038a8;
          }

          &:after {
            background-color: $color-purple-heart;
            border-radius: 100%;
            content: '';
            left: calc(50% - 4px);
            height: 8px;
            position: absolute;
            top: calc(50% - 4px);
            width: 8px;

            .themeBB & {
              background-color: #0038a8;
            }
          }
        }
      }

      &__label {
        cursor: pointer;
        flex: 1;
        font-family: $rubik-font-family;
        font-size: 16px;
        position: absolute;
        font-weight: normal;
        line-height: 1.5;
        color: #8e8e93;
        z-index: 1;
        right: 0;
        left: 0;
        text-align: center;
        cursor: pointer;

        input[type=radio]:checked ~ & {
          color: white;
        }

        b {
          font-weight: 500;
        }

        &__icon {
          position: absolute;
          top: -4px;
          right: -20px;
          width: 32px;
          height: 32px;
          background-image: url('~@/assets/arrow-right.svg');

          @media screen and (min-width: 375px) {
            right: 0;
          }
        }

        b {
          font-weight: 500;
        }

        &__icon {
          position: absolute;
          top: -4px;
          right: -20px;
          width: 32px;
          height: 32px;
          background-image: url('~@/assets/arrow-right.svg');

          @media screen and (min-width: 375px) {
            right: 0;
          }
        }
      }

      &__edit {
        cursor: pointer;
        margin-top: 4px;
        position: relative;
        width: 80px;

        &__icon {
          background-image: url('~@/assets/gear.svg');
          height: 24px;
          position: absolute;
          width: 24px;
        }

        &__label {
          font-family: $rubik-font-family;
          font-size: 16px;
          font-weight: 500;
          padding-left: 26px;
          text-decoration: underline;
        }

      }

      &__edit {
        cursor: pointer;
        margin-top: 4px;
        position: relative;
        width: 80px;

        &__icon {
          background-image: url('~@/assets/gear.svg');
          height: 24px;
          position: absolute;
          width: 24px;
        }

        &__label {
          font-family: $rubik-font-family;
          font-size: 16px;
          font-weight: 500;
          padding-left: 26px;
          text-decoration: underline;
        }

      }
    }
  }

  &__travelsDuration {

    @media only screen and (max-width: 767px) {
      text-align: center;
    }

    &__content {
      display: flex;
      margin-bottom: 24px;
      margin-top: 10px;

      @media only screen and (max-width: 767px) {
        align-items: center;
        justify-content: center;
      }
    }

    &__options {
      align-items: center;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      position: relative;

      @media only screen and (max-width: 455px) {
        padding: 0;
      }

      &:first-child {
        margin-right: 32px;

        @media only screen and (max-width: 455px) {
          margin-bottom: 14px;
        }
      }

      &__inputRadio {
        position: absolute;
        left: -9999px;
      }

      input[type=radio]:checked ~ &__bg {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }

      &__icon {
        border: 1px solid $color-silver-sand;
        border-radius: 100%;
        height: 16px;
        position: relative;
        width: 16px;

        input[type=radio]:checked ~ & {
          border-color: $color-purple-heart;

          .themeBB & {
            border-color: #0038a8;
          }

          &:after {
            background-color: $color-purple-heart;
            border-radius: 100%;
            content: '';
            left: calc(50% - 4px);
            height: 8px;
            position: absolute;
            top: calc(50% - 4px);
            width: 8px;

            .themeBB & {
              background-color: #0038a8;
            }
          }
        }
      }

      &__label {
        cursor: pointer;
        flex: 1;
        font-family: $rubik-font-family;
        font-size: 14px;
        margin-left: 8px;
        position: relative;
        font-weight: 500;
        z-index: 1;
        cursor: pointer;

        // &[for=multitrip]:after {
        //   background-image: url('~@/assets/new-seal.svg');
        //   background-repeat: no-repeat;
        //   content: '';
        //   left: 156px;
        //   height: 30px;
        //   position: absolute;
        //   top: -18px;
        //   width: 30px;

        //   @media screen and (min-width: 468px) {
        //     left: inherit;
        //     top: -18px;
        //   }
        // }

        b {
          font-weight: 500;
        }

        &__icon {
          position: absolute;
          top: -4px;
          right: -20px;
          width: 32px;
          height: 32px;
          background-image: url('~@/assets/arrow-right.svg');

          @media screen and (min-width: 375px) {
            right: 0;
          }
        }

        b {
          font-weight: 500;
        }

        &__icon {
          position: absolute;
          top: -4px;
          right: -20px;
          width: 32px;
          height: 32px;
          background-image: url('~@/assets/arrow-right.svg');

          @media screen and (min-width: 375px) {
            right: 0;
          }
        }
      }

      &__edit {
        cursor: pointer;
        margin-top: 4px;
        position: relative;
        width: 80px;

        &__icon {
          background-image: url('~@/assets/gear.svg');
          height: 24px;
          position: absolute;
          width: 24px;
        }

        &__label {
          font-family: $rubik-font-family;
          font-size: 16px;
          font-weight: 500;
          padding-left: 26px;
          text-decoration: underline;
        }

      }

      &__edit {
        cursor: pointer;
        margin-top: 4px;
        position: relative;
        width: 80px;

        &__icon {
          background-image: url('~@/assets/gear.svg');
          height: 24px;
          position: absolute;
          width: 24px;
        }

        &__label {
          font-family: $rubik-font-family;
          font-size: 16px;
          font-weight: 500;
          padding-left: 26px;
          text-decoration: underline;
        }

      }
    }
  }
}

.quotations {
  &__container {
    width: 100%;
    max-width: 1281px;
    margin: 44px auto;
    padding-left: 16px;
    padding-right: 16px;

    &-overflow {
      margin: 32px 32px -12px;
    }

    &--warning {
      background: #FDDFDF;
      border: 1px solid #DF2E24;
      border-radius: 8px;
      display: flex;
      padding: 14px 26px;
      margin-bottom: 30px;

      > span {
        font-size: 14px;
        font-weight: 600;
        color: #444;
        margin-left: 16px;
      }
    }
  }
}

.quotation-inline {
  width: 100%;
  min-height: 80px;
  background-color: #ebf0f5;
  border-bottom: 1px solid rgba(189, 194, 198, 0.7);
  position: relative;

  &--openBoxPassengers {
    @media screen and (max-width: 767px) {
      &:after {
        width: 100%;
        height: 100%;
        position: fixed;
        content: '';
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        z-index: 99;
      }
    }
  }

  @media screen and (max-width: 884px) {
    min-height: 58px;
  }

  &__arrow {
    background-color: $color-purple-heart;
    border-radius: 100%;
    width: 32px;
    height: 32px;
    position: absolute;
    right: 32px;
    top: calc(50% - 16px);
    transition: transform .3s,-webkit-transform .3s;
    border: none;
    cursor: pointer;

    @media screen and (min-width: 1128px) {
      display: none;
    }

    &:after {
      background: url('~@/assets/quotation-arrow.svg') no-repeat;
      width: 29px;
      height: 25px;
      content: '';
      left: -4px;
      top: -3px;
      position: absolute;
    }

    &:disabled {
      opacity: .4;
    }

    &--open {
      top: 13px;
      transform: rotate(180deg);

      @media screen and (min-width: 885px) {
        top: 24px;
      }

      @media screen and (min-width: 1128px) {
        display: none;
      }
    }

    .themeBB & {
      background-color: #0038a8;
    }
  }

  &__resume {
    width: 100%;
    display: block;

    @media screen and (max-width: 884px) {
      display: none;
    }

    &--hide {
      display: none;
    }

    &__list {
      align-items: center;
      display: flex;
      height: 80px;
      justify-content: center;

      &__item {
        position: relative;
        padding: 0 46px 0 16px;

        &:after {
          position: absolute;
          background-repeat: no-repeat;
          width: 32px;
          height: 32px;
          left: 0;
          top: -5px;
          content: '';
        }

        &--destiny:after {
          background-image: url('~@/assets/icons/destiny.svg');

          .themeBB & {
            background-image: url('~@/assets/icons/bb-destiny.svg');
          }
        }

        &--passengers:after {
          background-image: url('~@/assets/icons/person.svg');

          .themeBB & {
            background-image: url('~@/assets/icons/bb-person.svg');
          }
        }

        &--travelsDate:after {
          background-image: url('~@/assets/icons/travel-calendar.svg');

          .themeBB & {
            background-image: url('~@/assets/icons/bb-travel-calendar.svg');
          }
        }

        &__label {
          font-weight: 500;
          font-size: 16px;
          color: $color-tundora;
          font-family: $rubik-font-family;
          margin-left: 23px;
        }

        &__button {
          width: 185px;
          background-color: transparent;
          border-radius: 30px;
          border: 1px solid $color-purple-heart;
          color: $color-purple-heart;
          font-size: 14px;
          font-weight: bold;
          font-family: Oscine;
          text-transform: uppercase;
          padding: 11px;
          cursor: pointer;

          @media screen and (max-width: 1127px) {
            display: none;
          }

          .themeBB & {
            border-color: #0038a8;
            color: #0038a8;
          }
        }

      }
    }
  }

  &__collapse {
    color: $color-tundora;
    display: none;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    padding: 13px 15px;
    font-family: $oscine-font-family;

    @media screen and (max-width: 884px) {
      display: block;
    }
  }

  &__container {
    max-width: 1281px;
    margin: 0 auto;

    @media screen and (max-width: 1320px) {
      padding-left: 32px;
      padding-right: 32px;
    }

    @media screen and (max-width: 400px) {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  &__form {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    padding: 0 0 40px 0;
    padding-top: 10px;

    @media screen and (max-width: 767px) {
      max-width: 292px;
      margin-inline: auto;
    }

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    @media screen and (max-width: 1240px) {
      flex-wrap: wrap;
    }
  }

  &__fieldset {
    width: 100%;
    position: relative;

    &--type {
      flex-shrink: 0;

      @media screen and (min-width: 768px) {
        max-width: 285px;
      }
    }

    &--destiny {
      @media screen and (min-width: 768px) and (max-width: 1242px){
        max-width: 300px;
      }
    }

    &--travelsDate {
      display: flex;
      justify-content: space-between;
      gap: 8px;

      &__initialDate,
      &__endDate {
        width: 100%;
      }

      @media screen and (min-width: 768px) {
        max-width: 230px;
      }
    }

    &--passengers {
      @media screen and (min-width: 768px) {
        max-width: 140px;
      }
    }
  }

  &__label {
    font-size: 16px;
    color: $color-tundora;
    font-family: Oscine;
    display: block;
    margin-bottom: 8px;
  }

  &__select,
  &__input {
    width: 100%;
    min-height: 40px;
    background-color: $white;
    color: $color-scorpion;
    border: 1px solid $color-silver-sand;
    border-radius: 8px;
    padding: 8px 16px;

    @media screen and (min-width: 811px) {
      padding: 8px 18px;
    }

    &__brasil {
      line-height: 30px;
    }
  }

  &__select,
  &__select-input {
    appearance: none;
    background-image: url('~@/assets/arrow-down.svg');
    background-repeat: no-repeat;
    background-position: right 12px center;
  }

  &__select-input {
    background-color: $white;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid $color-silver-sand;
    font-size: .9em;
    margin-top: 6px;
    outline: none;
    padding: 6px 2px;
    width: 100%;
    z-index: 0;
  }

  &__select,
  &__input {
    cursor: pointer;
  }

  &__passengers {
    background-color: $white;
    border-radius: 8px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(189, 194, 198, 0.5);
    border-top: none;
    padding: 12px;
    position: absolute;
    width: 100%;
    min-width: 254px;
    z-index: 999;
    margin-top: 12px;
    padding: 32px 24px 16px 24px;

    @media screen and (max-width: 1024px) and (min-width: 811px) {
      left: -110px;
    }

    @media screen and (max-width: 767px) {
      max-width: 288px;
      position: fixed;
      top: calc(50% - 100px);
    }

    &__group {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 20px;
      }

      &__label {
        font-family: $rubik-font-family;
        font-size: 14px;
        max-width: 90px;
        color: $color-tundora;

        @media screen and (max-width: 390px) {
          & span {
            display: block;
          }
        }
      }

      &__numberPassengers {
        display: flex;
        align-items: center;

        &__btn {
          background-color: $white;
          border: 1px solid $color-scorpion;
          border-radius: 50%;
          cursor: pointer;
          height: 29px;
          padding: 0;
          position: relative;
          outline: none;
          width: 29px;

          &:before {
            content: '';
            height: 30px;
            left: calc(50% - 15px);
            position: absolute;
            top: calc(50% - 15px);
            width: 30px;
          }

          &:disabled {
            opacity: 0.3;
            border: solid 1px $color-tundora;
            color: $color-tundora;
          }
        }

        &__label {
          font-family: $rubik-font-family;
          font-size: 14px;
          text-align: center;
          width: 18px;
          margin: 0 12px 0;
          color: $color-tundora;
        }
      }
    }

    &__disclaimer {
      color: #595959;
      font-family: $rubik-font-family;
      font-size: 14px;
      margin-bottom: 20px;

      &__icon {
        margin-right: 6px;
        width: 15px;
      }

      &__icon, &__text {
        vertical-align: middle;
      }
    }

    &__btnApply {
      background: none;
      border: none;
      color: $color-purple-heart;
      cursor: pointer;
      float: right;
      font-family: $rubik-font-family;
      font-size: 16px;
      outline: none;
      font-weight: normal;

      .themeBB & {
        color: #0038a8;
      }
    }
  }

  &__button {
    width: 100%;
    max-width: 292px;
    height: 40px;
    border-radius: 30px;
    font-size: 16px;
    background-color: $color-purple-heart;
    color: $white;
    font-family: Oscine;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    margin-top: 24px;
    border: none;
    cursor: pointer;

    @media screen and (min-width: 1025px) {
      max-width: 182px;
      font-size: 14px;
      margin-top: 32px;
      margin-left: 32px;
    }

    @media screen and (max-width: 810px) and (min-width: 768px) {
      margin-top: 50px;
      margin-left: 16px;
    }

    &:disabled {
      opacity: .4;
    }

    .themeBB & {
      background-color: #0038a8;
    }
  }

  &__formMultitrip {
    .quotation-inline__fieldset {
      max-width: 292px;

      &--travelsDate {
        width: 100%;

        &__initialDate {
          width: 100%;
          max-width: 292px;
        }
      }
    }
    .quotation-inline__button {
      @media screen and (min-width: 864px) {
        max-width: 182px;
      }
    }
  }

  &__inputInvalid {
    border-color: #DF2E24;
  }
}
</style>
